import { FC, useContext } from 'react'
import DownloadBlankPreviewFiles from '../../../../../components/buttons/download-blank-preview-files/download-blank-preview-files'
import Task from '../../../../../types/api/task'
import { DesignerTasksScaleContext } from '../../../constants/scale-context'

interface BlankPreviewFileProps {
    task: Task
}

const BlankPreviewFile: FC<BlankPreviewFileProps> = ({ task }) => {
    const isLarge = useContext(DesignerTasksScaleContext) === 'large'
    const shipment = task.shipment
    if (!shipment?.documentId) return null

    return (
        <DownloadBlankPreviewFiles
            shipmentDocumentId={shipment.documentId}
            blankPreviewFiles={shipment.blankPreviewFiles}
            size={isLarge ? 'middle' : 'small'}
        />
    )
}

export default BlankPreviewFile
